import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addEndpoint = ApiEndpoints.dynamicPage.Create;
const authorListEndpoint = ApiEndpoints.autor.authorList;

export default function AddDynamicPage() {
  const navigate = useNavigate();
  const [authors, setAuthors] = useState([]);

  const [previews, setPreviews] = useState({ banner_image: null, first_section_image: null, second_section_image: null });
  const [postData, setPostData] = useState({ title: "", slug: "", banner_image: null, alt_banner_image: "", banner_description: "", banner_button_url: "", banner_button_name: "", service_overview_title: "", service_overview_description: "",  first_section_title: "", first_section_description: "", first_section_image: null, first_section_image_alt: "", second_section_title: "", second_section_subtitle: "", second_section_description: "", second_section_image: null, second_section_image_alt: "", quotes: "", author_id: "", date: new Date(), stat_one_number:"", stat_one_description:"",stat_two_number:"", stat_two_description:"", stat_three_number:"", stat_three_description:"",
    faqs: [{ question: "", answer: "" }, { question: "", answer: "" },]
  });

  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        const response = await ApiRequest("GET", authorListEndpoint);
        setAuthors(response?.authors || []);
      } catch (error) {
        console.error("Failed to fetch authors:", error);
        setAuthors([]);
      }
    };

    fetchAuthors();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (value === "" || value === null) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (key === "faqs") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await ApiRequest("POST", addEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/dynamic-page");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };


  // =========FAQS Functionality==========

  // 🔹 handle change for question/answer
  const handleFaqChange = (index, field, value) => {
    setPostData((prev) => {
      const updatedFaqs = [...prev.faqs];
      updatedFaqs[index][field] = value;
      return { ...prev, faqs: updatedFaqs };
    });
  };

  // 🔹 add new FAQ
  const addFaq = () => {
    setPostData((prev) => ({
      ...prev,
      faqs: [...prev.faqs, { question: "", answer: "" }],
    }));
  };

  // 🔹 remove FAQ
  const removeFaq = (index) => {
    setPostData((prev) => ({
      ...prev,
      faqs: prev.faqs.filter((_, i) => i !== index),
    }));
  };

  // =======FAQs Functionality End==========

  const pagename = {
    name: 'dynamic page Management',
    user: 'Admin',
    innerpage: 'dynamic page Management / Add dynamic page'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="addDynamic" onSubmit={handleSubmit}>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12"><h5>Banner Section</h5></div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input value={postData?.title} onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input value={postData?.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="Enter Date" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>banner button name<small>*</small></label>
                  </div>
                  <input value={postData?.banner_button_name} onChange={handleChange} name="banner_button_name" type="text" className="form-control" placeholder="Enter Here" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>banner button slug<small>*</small></label>
                  </div>
                  <input value={postData?.banner_button_url} onChange={handleChange} name="banner_button_url" type="text" className="form-control" placeholder="Enter Here" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Banner Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.banner_description} onChange={(event, editor) => handleEditorChange("banner_description", editor.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Banner Image Alt Text<small>*</small></label>
                  </div>
                  <input value={postData?.alt_banner_image} onChange={handleChange} name="alt_banner_image" type="text" className="form-control" placeholder="Enter Here" />
                </div>

                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (960 × 944)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.banner_image}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12"><h5>Service Overview Section</h5></div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Service Overview Title<small>*</small></label>
                  </div>
                  <input value={postData?.service_overview_title} onChange={handleChange} name="service_overview_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Service Overview Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.service_overview_description} onChange={(event, editor) => handleEditorChange("service_overview_description", editor.getData())} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12"><h5>First Section</h5></div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>First Section Title<small>*</small></label>
                  </div>
                  <input value={postData?.first_section_title} onChange={handleChange} name="first_section_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>              

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>first Section Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.first_section_description} onChange={(event, editor) => handleEditorChange("first_section_description", editor.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>First Section Image Alt Text<small>*</small></label>
                  </div>
                  <input value={postData?.first_section_image_alt} onChange={handleChange} name= "first_section_image_alt" type="text" className="form-control" placeholder="Enter Here" />
                </div>

                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>First Section Image (840 × 688)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="first_section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.first_section_image}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12"><h5>Stats Section</h5></div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat One Number<small>*</small></label>
                  </div>
                  <input value={postData?.stat_one_number} onChange={handleChange} name="stat_one_number" type="text" className="form-control" placeholder="Enter Here" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat One Description<small>*</small></label>
                  </div>
                  <input value={postData?.stat_one_description} onChange={handleChange} name="stat_one_description" type="text" className="form-control" placeholder="Enter Here" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat two Number<small>*</small></label>
                  </div>
                  <input value={postData?.stat_two_number} onChange={handleChange} name="stat_two_number" type="text" className="form-control" placeholder="Enter Here" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat two Description<small>*</small></label>
                  </div>
                  <input value={postData?.stat_two_description} onChange={handleChange} name="stat_two_description" type="text" className="form-control" placeholder="Enter Here" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat Three Number<small>*</small></label>
                  </div>
                  <input value={postData?.stat_three_number} onChange={handleChange} name="stat_three_number" type="text" className="form-control" placeholder="Enter Here" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat Three Description<small>*</small></label>
                  </div>
                  <input value={postData?.stat_three_description} onChange={handleChange} name="stat_three_description" type="text" className="form-control" placeholder="Enter Here" />
                </div>
              </div>
            </div>
          </div>


          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12"><h5>Second Section</h5></div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Second Section Title<small>*</small></label>
                  </div>
                  <input value={postData?.second_section_title} onChange={handleChange} name="second_section_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>              

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Second Section Sub Title<small>*</small></label>
                  </div>
                  <input value={postData?.second_section_subtitle} onChange={handleChange} name="second_section_subtitle" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>              

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>second Section Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.second_section_description} onChange={(event, editor) => handleEditorChange("second_section_description", editor.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>second Section Image Alt Text<small>*</small></label>
                  </div>
                  <input value={postData?.second_section_image_alt} onChange={handleChange} name= "second_section_image_alt" type="text" className="form-control" placeholder="Enter Here" />
                </div>

                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>second Section Image (706 × 706)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="second_section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.second_section_image}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12"><h5>Quote Section</h5></div>   

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="author_id" options={authors} placeholder="Select Author Name" />
                </div>
              </div>              

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Quote Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.quotes} onChange={(event, editor) => handleEditorChange("quotes", editor.getData())} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <h5>Faq Section</h5>
            <div className="row">

              {postData.faqs.map((faq, index) => (
                <div key={index} className="col-lg-6" style={{ position: "relative" }}>
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Question<small>*</small></label>
                    </div>
                    <input required className="form-control" type="text" placeholder={`Question ${index + 1}`} value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                  </div>

                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Answer<small>*</small></label>
                    </div>
                    <input required className="form-control" placeholder={`Answer ${index + 1}`}
                      value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)} />
                  </div>
                  {index >= 2 && (
                    <button type="button" style={{ position: "absolute", background: "linear-gradient(270deg,#e20814,#a80008)", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "12px", padding: "3px 15px" }} onClick={() => removeFaq(index)}>
                      REMOVE
                    </button>
                  )}
                </div>
              ))}

              <div className="col-lg-12 text-center">
                <button type="button" className="add-faqs" onClick={addFaq} style={{ background: "green", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "14px", padding: "5px 15px", marginTop: "15px" }}>
                  Add New Faq
                </button>
              </div>
            </div>
          </div>

        </form>
        <button type="submit" form="addDynamic" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
